<template>
  <span class="NewActivityIcon" :class=iconName :style="styleObject" @click="onClicked" v-hover="onHoverOverNewButton">
    <NewActivityIconAsset/>
    <!--
      <span class="hover-info">
        <span class="content">
          <p>{{ hoverName }}</p>
        </span>
      </span>
      -->
  </span>
  <HoverInfo :show="hoveringOverNewButton" :content="'Nieuwe opdracht'" :offset-y="12" :offset-x="12"></HoverInfo>
</template>

<script>
import HoverInfo from "@/components/UI/HoverInfo.vue";
import NewActivityIconAsset from "@/assets/image/icons/icon_newactivity.svg?inline";


export default {
  name: "NewActivityIcon",
  components: {HoverInfo, NewActivityIconAsset},
  data() {
    return {
      styleObject: {
        fontSize: this.iconSize,
        fill: this.color
      },
      hoveringOverNewButton: false
    };
  },
  props: {
    show: Boolean,
    color: {
      type: String,
      default: "black"
    },
    hoverName: {
      type: String,
      default: "Icon"
    },
    iconName: String,
    iconSize: {
      type: String,
      default: "1rem"
    }
  },
  computed: {},
  methods: {
    onClicked() {
      this.$emit("clicked");
    },
    onHoverOverNewButton(state) {
      this.hoveringOverNewButton = state;
    }
  }
}
</script>

<style lang="scss" scoped>
.NewActivityIcon {
  position: relative;
  right: -10px;
  
  &:hover {
    .hover-info {
      visibility: visible;
    }
  }

  .hover-info {
    visibility: hidden;
  }
}

.hover-info {
  position: relative;
  left: 0;
  top: 0;
  z-index: 999;

  .content {
    position: absolute;
    left: 0;
    top: -100;
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    box-shadow: $default-shadow;
    min-width: 100px;
    text-align: center;
    cursor: auto;

    p {
      margin-bottom: 0;
      cursor: auto;
    }
  }
}
</style>